import { render, staticRenderFns } from "./AudioView.vue?vue&type=template&id=052d78a8&scoped=true"
import script from "./AudioView.vue?vue&type=script&lang=js"
export * from "./AudioView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052d78a8",
  null
  
)

export default component.exports